
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

@Component
export default class ContractWithdrawalResult extends Vue {
    @Prop({ type: String }) email!: string;

    private get content(): string {
        return this.$localize("contract_withdrawal.result.message.text", this.email);
    }
}
